import { SEARCH_USERS, SEARCH_USERS_SUCCESS, SEARCH_USERS_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  searchResults: [],
};

const searchUsersReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SEARCH_USERS:
      return { ...state, loading: true };
    case SEARCH_USERS_SUCCESS:
      return {
        ...state,
        searchResults: action?.payload,
        loading: false,
      };
    case SEARCH_USERS_FAILURE:
      return { ...state, loading: false, searchResults: [] };
    default:
      return state;
  }
};

export default searchUsersReducer;
